import style from "./FooterMain.module.css"
export function FooterMain() {
    return (
        <div>
            <div className={style.footer}>
                <div className={`${style.main_row} ${style.flex}`}>
                    <div className={style.fotr_col_2}>
                        <h3>Information</h3>
                        <a href="null"><td>About us</td></a><br />
                        <a href="null"><td>Terms and condition</td></a><br />
                        <a href="null"><td>Careers with us</td></a><br />
                        <a href="null"><td>Sitemap</td></a><br />
                        <a href="null"><td>Contact us</td></a><br />
                        <a href="null"><td>FAQs</td></a><br />
                        <a href="null"><td>Summons/Notices</td></a><br />
                        <a href="null"><td>Grievances</td></a><br />
                        <a href="null"><td>Fraud Alter</td></a><br />
                        <a href="null"><td>Trust and sefety</td></a><br />
                        <br />
                        <div className={style.fotr_col_1}>
                            <h2>Naukri on Mobile</h2>
                            <tbody className={style.share_icon}>
                                <td>
                                    <img style={{ width: "150px", height: "40px" }} src="https://static.naukimg.com/s/0/0/i/new-homepage/android-app.png" alt="google" />
                                </td><br />
                                <td><img style={{ width: "150px", height: "40px" }} src="https://static.naukimg.com/s/0/0/i/new-homepage/ios-app.png" alt="apple" /></td>
                            </tbody>
                        </div>
                    </div>
                    <div className={style.fotr_col_3}>
                        <h3>Jobseekers</h3>
                        <a href="null"><td>Register Now</td></a><br />
                        <a href="null"><td>Job search</td></a><br />
                        <a href="null"><td>Login</td></a><br />
                        <a href="null"><td>Create job Alert</td></a><br />
                        <a href="null"><td>Report a Problem</td></a><br />
                        <a href="null"><td>Naukri Blogs</td></a><br />
                        <a href="null"><td>Mobile Site</td></a><br />
                        <br />
                        <h3>Browse Jobs</h3>
                        <a href="null"><td>Browse all job</td></a><br />
                        <a href="null"><td>Premium MBA job</td></a><br />
                        <a href="null"><td>Premium Engineering job</td></a><br />
                        <a href="null"><td>Govt. job</td></a><br />
                        <a href="null"><td>Internation job</td></a><br />
                        <a href="null"><td>Jobs in Gulf</td></a><br />
                        <a href="null"><td>Jobs by Company</td></a><br />
                        <a href="null"><td>Jobs by Category</td></a><br />
                        <a href="null"><td>Jobs by destination</td></a><br />
                        <a href="null"><td>Jobs by location</td></a><br />
                        <a href="null"><td>Jobs by skill</td></a><br />
                    </div>
                    <div className={style.fotr_col_4}>
                        <h3>Jobseeker Services</h3>
                        <a href="null"><td>Priority Applicant</td></a><br />
                        <a href="null"><td>Resume display</td></a><br />
                        <a href="null"><td>Resume writting</td></a><br />
                        <a href="null"><td>Job4u</td></a><br />
                        <a href="null"><td>Recruiter Connection</td></a><br />
                        <br />
                        <h3>Naukri Learning</h3>
                        <a href="null"><td>Softer and technology</td></a><br />
                        <a href="null"><td>AI AND DS</td></a><br />
                        <a href="null"><td>Management</td></a><br />
                        <a href="null"><td>Finance</td></a><br />
                        <a href="null"><td>Creativity and Design</td></a><br />
                        <a href="null"><td>Emerging Technology</td></a><br />
                        <a href="null"><td>Engineering non CS</td></a><br />
                        <a href="null"><td>Healthcare</td></a><br />
                        <a href="null"><td>Enery and Enviroment</td></a><br />
                        <a href="null"><td>Social Science</td></a><br />
                        <a href="null"><td>Personal Growth</td></a><br />
                    </div>
                    <div className={style.fotr_col_5}>
                        <h3>Employers</h3>
                        <a href="null"><td>Job posting</td></a><br />
                        <a href="null"><td>Resume database access</td></a><br />
                        <a href="null"><td>Recruiter Login</td></a><br />
                        <a href="null"><td>Naurkri RMS</td></a><br />
                        <a href="null"><td>By resume package online</td></a><br />
                        <a href="null"><td>Transition services</td></a><br />
                        <a href="null"><td>report a problem</td></a><br />
                        <a href="null"><td>Recruite from USA ,call</td></a><br />
                        <a href="null"><td>Toll Free # 1866-557-3340</td></a><br />
                        <br />
                        <h3>Ambition Box</h3>
                        <a href="null"><td>Inverview Question</td></a><br />
                        <a href="null"><td>About Companies</td></a><br />
                        <a href="null"><td>Share interview advice</td></a><br />
                        <a href="null"><td>Write company review</td></a><br />
                        <a href="null"><td>Companies reviews</td></a><br />
                        <a href="null"><td>Companies salaries</td></a><br />
                        <a href="null"><td>Follow us</td></a><br />
                        <div className={style.fotr_col_1}>
                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
} 